import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import Footer from '../components/Footer';

export const ProjectConceptsPage: React.FC = () => {
  return (
    <div
      style={{
        background: '#0a0a0f',
        minHeight: '100vh',
        color: '#ffffff',
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <Navbar />

      <div style={{ maxWidth: 1080, margin: '0 auto', padding: '80px 24px 96px' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <h1
            style={{
              fontSize: 42,
              fontWeight: 800,
              letterSpacing: -1,
              background: 'linear-gradient(135deg, #60a5fa, #a78bfa, #34d399)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              marginBottom: 14,
            }}
          >
            Product Concepts
          </h1>
          <p
            style={{
              fontSize: 17,
              color: '#94a3b8',
              maxWidth: 760,
              margin: '0 auto',
              lineHeight: 1.6,
            }}
          >
            Explore the evolution of the Autar platform concept from the original version to the
            separated diagram and architecture descriptions.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <Link
            to="/AutarPlatformV2Diagram"
            style={{
              background: 'rgba(15, 15, 25, 0.9)',
              border: '1px solid rgba(148, 163, 184, 0.2)',
              borderRadius: 16,
              padding: 24,
              textDecoration: 'none',
              color: '#ffffff',
              display: 'block',
            }}
          >
            <h2 style={{ fontSize: 22, marginBottom: 12, color: '#e2e8f0', letterSpacing: -0.4 }}>
              Autar Platform
            </h2>
            <p style={{ margin: 0, color: '#94a3b8', lineHeight: 1.6 }}>
              Updated platform cycle diagram with renamed engines and AutarAGENT.
            </p>
          </Link>
          <div style={{ display: 'flex', gap: 20, justifyContent: 'flex-end' }}>
            <Link
              to="/AutarPlatformV2Descriptions"
              style={{
                flex: 1,
                background: 'rgba(15, 15, 25, 0.9)',
                border: '1px solid rgba(148, 163, 184, 0.15)',
                borderRadius: 16,
                padding: 24,
                textDecoration: 'none',
                color: '#64748b',
                display: 'block',
              }}
            >
              <h2 style={{ fontSize: 22, marginBottom: 12, color: '#64748b', letterSpacing: -0.4 }}>
                AutarPlatform Descriptions
              </h2>
              <p style={{ margin: 0, color: '#475569', lineHeight: 1.6 }}>
                Detailed engine descriptions without the diagram view.
              </p>
            </Link>
            <Link
              to="/AutarPlatform"
              style={{
                flex: 1,
                background: 'rgba(15, 15, 25, 0.9)',
                border: '1px solid rgba(148, 163, 184, 0.15)',
                borderRadius: 16,
                padding: 24,
                textDecoration: 'none',
                color: '#64748b',
                display: 'block',
              }}
            >
              <h2 style={{ fontSize: 22, marginBottom: 12, color: '#64748b', letterSpacing: -0.4 }}>
                AutarPlatform Early Concept
              </h2>
              <p style={{ margin: 0, color: '#475569', lineHeight: 1.6 }}>
                Original JD concept page with full diagram and narrative.
              </p>
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ProjectConceptsPage;
